export const initCollapsible = () => {
  const blocks = Array.from(document.querySelectorAll('.c-collapsible'));
  if (blocks.length === 0) {
    return;
  }

  blocks.forEach((block) => {
    const toggle = block.parentElement?.querySelector('.c-collapsible__toggle');
    if (!toggle) {
      return;
    }

    const maxValue = block.dataset.collapsibleMax || '500';
    const maxHeight = `${Number(maxValue)}px`;
    block.style.setProperty('--collapsible-max', maxHeight);

    const labelMore = block.dataset.collapsibleMore || 'Read more';
    const labelLess = block.dataset.collapsibleLess || 'Read less';

    const needsToggle = block.scrollHeight > Number(maxValue) + 8;
    if (!needsToggle) {
      toggle.setAttribute('hidden', 'true');
      return;
    }

    const blockId = block.id || `collapsible-${Math.random().toString(36).substr(2, 9)}`;
    if (!block.id) {
      block.id = blockId;
    }
    toggle.setAttribute('aria-controls', blockId);
    
    toggle.addEventListener('click', () => {
      const isExpanded = block.classList.toggle('is-expanded');
      toggle.setAttribute('aria-expanded', String(isExpanded));
      toggle.textContent = isExpanded ? labelLess : labelMore;
    });
  });
};
